import _ from "lodash";
import { useOcRoleFilter } from "oc/hooks/use-role-filter/use-role-filter";
import { RoleFilterInput } from "oc/types";

// TODO f Change name?
export const useOcRoleFilters = ({
  contract,
  product,
  role,
  id = "default",
}: {
  contract: string;
  product: string;
  role: string;
  id?: string;
}) => {
  const stateId = product + role + contract + id;
  const prevStateId = "prev" + product + role + contract + id;

  const {
    roleFilters,
    setRoleFilters,
    reset: resetRoleFilters,
  } = useOcRoleFilter(stateId);
  const { roleFilters: prevRoleFilters, setRoleFilters: setPrevRoleFilters } =
    useOcRoleFilter(prevStateId);

  const handleAddFilter = ({
    key,
    value,
  }: {
    key: keyof RoleFilterInput;
    value: string | string[];
  }) => {
    let newState = _.cloneDeep(roleFilters);
    if (typeof value === "object") newState[key] = value;
    else if (_.isEqual(newState[key], ["-"])) newState[key] = [value];
    else newState[key] = (newState[key] ?? []).concat([value]);

    setRoleFilters(newState);
  };

  const handleRemoveFilter = ({
    key,
    value,
  }: {
    key: keyof RoleFilterInput;
    value: any;
  }) => {
    let newState = _.cloneDeep(roleFilters);
    if (newState[key] && Array.isArray(newState[key])) {
      newState[key] = newState[key]?.filter((item: any) => item !== value);
    }
    setRoleFilters(newState);
  };

  // TODO f Could also put handleItemClick here, if isAllSelected is given to it as a prop?

  const isTouched = !_.isEqual(roleFilters, prevRoleFilters);

  return {
    roleFilters,
    setRoleFilters,
    prevRoleFilters,
    setPrevRoleFilters,
    resetRoleFilters,
    handleAddFilter,
    handleRemoveFilter,
    isTouched,
  };
};

export default useOcRoleFilters;
